import { render, staticRenderFns } from "./GroupGuideInfo.vue?vue&type=template&id=615f650a"
import script from "./GroupGuideInfo.vue?vue&type=script&lang=js"
export * from "./GroupGuideInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports